module.exports = __webpack_public_path__ + "img/電気回路_6_10_3.b8717a56.png";